import { Box, Typography } from "@mui/material";

export const SkillsListEmpty = () => (
  <Box sx={{ py: 0.875, px: 1.3125 }} data-testid="skills-list-empty">
    <Typography color="text.secondary">No skills found.</Typography>
  </Box>
);
